// language=GraphQL
export const ALL_FILES_QUERY = `query Query {
  files: mediaFiles {
    id
    assetId
    publicId
    url
    resourceType
    format
    width
    height
    caption
    title
    description
  }
}`

// language=GraphQL
export const SINGLE_FILE_QUERY = `query Query($id: ID!) {
  file: mediaFile(id: $id) {
    id
    assetId
    publicId
    url
    resourceType
    format
    width
    height
    caption
    title
    description
  }
}`

// language=GraphQL
export const CREATE_FILE_MUTATION = `
  mutation Mutation($input: CreateMediaFileInput) {
    file: createMediaFile(input: $input) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }`

// language=GraphQL
export const UPDATE_FILE_MUTATION = `
  mutation Mutation($input: UpdateMediaFileInput) {
    file: updateMediaFile(input: $input) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }`

// language=GraphQL
export const DELETE_FILE_MUTATION = `
  mutation Mutation($input: DeleteMediaFileInput) {
    deleteMediaFile(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_FILE_MUTATION = `
  mutation Mutation($input: DeleteMediaFileInput) {
    forceDeleteMediaFile(input: $input) {
      success
    }
  }`
// language=GraphQL
export const FILES_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsTextWithImageBlocks: Boolean = false, $withCmsTextWithIconBlocks: Boolean = false, $withCmsPageHeaderBlocks: Boolean = false, $withElementSeoSettings: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withTravelPartners: Boolean = false, $withTravelGuides: Boolean = false, $withEmployees: Boolean = false, $withTravels: Boolean = false, $withTravelExtensions: Boolean = false, $withCmsImageBlocks: Boolean = false, $withTravelTypes: Boolean = false, $withTravelPricingBrandings: Boolean = false, $withItineraryItems: Boolean = false, $withCmsHeaderSliderBlockSlides: Boolean = false, $withTravelFaqs: Boolean = false, $withImageGalleries: Boolean = false) {
  groupedDependents: mediaFileDependents(id: $id) {
    cmsTextWithImageBlocks @include(if: $withCmsTextWithImageBlocks) {
      id
      title
      subtitle
      text
      imagePosition
      imageFixedAspectRatio
    }
    cmsTextWithIconBlocks @include(if: $withCmsTextWithIconBlocks) {
      id
      title
      text
      imagePosition    }
    cmsPageHeaderBlocks @include(if: $withCmsPageHeaderBlocks) {
      id
      title
      text
    }
    elementSeoSettings @include(if: $withElementSeoSettings) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
    }
    accommodationAvailableAddons @include(if: $withAccommodationAvailableAddons) {
      id
      name
      description
    }
    travelPartners @include(if: $withTravelPartners) {
      id
      name
      url
      logoWidth
    }
    travelGuides @include(if: $withTravelGuides) {
      id
      firstName
      lastName
      description
    }
    employees @include(if: $withEmployees) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      phone    }
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
    travelExtensions @include(if: $withTravelExtensions) {
      id
      duration
      name
      description
    }
    cmsImageBlocks @include(if: $withCmsImageBlocks) {
      id
      text
      fluid    }
    travelTypes @include(if: $withTravelTypes) {
      id
      name
      description
    }
    travelPricingBrandings @include(if: $withTravelPricingBrandings) {
      id
      logoWidth    }
    itineraryItems @include(if: $withItineraryItems) {
      id
      duration
      title
      text
    }
    cmsHeaderSliderBlockSlides @include(if: $withCmsHeaderSliderBlockSlides) {
      id
      title
      text
    }
    travelFaqs @include(if: $withTravelFaqs) {
      id
      question
      answer    }
    imageGalleries @include(if: $withImageGalleries) {
      id
    }
  }
}`
